import { z } from 'zod';
export const LocationSchema = z.object({
    lat: z.number().min(-90).max(90),
    lng: z.number().min(-180).max(180),
    address: z.string().optional(),
    accuracy: z.number().positive().optional(),
    timestamp: z.string().datetime().optional(),
});
export const DistanceMatrixSchema = z.object({
    origins: z.array(LocationSchema),
    destinations: z.array(LocationSchema),
});
export const DistanceResultSchema = z.object({
    distanceKm: z.number(),
    durationMin: z.number().int(),
    durationTrafficMin: z.number().int().optional(),
});
export const NearbyAgentSchema = z.object({
    agentId: z.string().uuid(),
    lat: z.number(),
    lng: z.number(),
    distanceM: z.number().int(),
    vehicleType: z.string(),
    rating: z.number(),
    isAvailable: z.boolean(),
});
